<template>
    <div class="auction-detail-modal">
        <div class="auction-detail-modal__title">
            {{ 'Продление аукциона' }}
        </div>

        <div class="auction-detail-modal__info">
            <UISelect
                id="prolong_minutes"
                v-model="prolongMinutes"
                :options="prolongMinutesOptions"
                label="Время продления"
            />

            <div class="auction-detail-modal__time">
                <div class="auction-detail-modal__time-label">Новое время окончания аукциона</div>
                <div class="auction-detail-modal__time-value">{{ auctionNewEndDate }}</div>
            </div>
        </div>

        <div class="auction-detail-modal__buttons">
            <UISimpleButton
                class="auction-detail-modal__button"
                @clicked="onConfirmed(prolongMinutes)"
            >
                Подтвердить
            </UISimpleButton>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed, ref } from 'vue';

    import { DateTime } from 'luxon';

    import { Auction } from '@/types/auction.type.ts';

    import UISelect from '@/components/ui/UISelect/UISelect.vue';
    import UISimpleButton from '@/components/ui/UISimpleButton/UISimpleButton.vue';

    const { auction } = defineProps<{
        auction: Auction,
        onConfirmed: (minutes: number) => void,
    }>();

    const prolongMinutes = ref<number>(30);
    const prolongMinutesOptions = ref([
        { label: '30 минут', value: 30 },
        { label: '60 минут', value: 60 },
    ]);

    const auctionNewEndDate = computed(() => {
        const localizedEndDate = DateTime.fromSQL(auction.end_date, { zone: 'UTC' }).toLocal();

        return localizedEndDate.plus({ minute: prolongMinutes.value }).toFormat('dd.LL.yyyy HH:mm');
    });
</script>

<style scoped lang="scss">
    @use './ContinueAuctionModal.scss' as *;
</style>
